<template>
  <div>
    <b-card title="Görsel">
      <b-img
        v-if="dataItem.image"
        :src="imageUrl + '/media/corporate_policies/' + dataItem.image"
        thumbnail
        center
      />
      <div class="text-center mt-1">
        <b-button
          variant="primary"
          @click="setModal('corporate_policies')"
        >
          <FeatherIcon icon="UploadIcon" />
          Görsel Yükle
        </b-button>
      </div>
    </b-card>
    <cropper-image
      v-if="cropperSettings.type"
      :modal-status="cropperSettings.modalStatus"
      :close-modal="closeModal"
      :file-name="cropperSettings.fileName"
      :folder="cropperSettings.folder"
      :ratio="cropperSettings.ratio"
      :width-size="cropperSettings.widthSize"
      component="corporate_policies"
      :params="cropperSettings.type"
      :item-id="dataItem.id"
      @uploadImage="setUploadImage"
    />
  </div>
</template>
<script>
import { BCard, BImg, BButton } from 'bootstrap-vue'
import CropperImage from '@/layouts/components/common/CropperImage.vue'
import { required } from '@core/utils/validations/validations'

export default {
  name: 'CorporatePoliciesImageCard',
  components: {
    BCard,
    BImg,
    BButton,
    CropperImage,
  },
  data() {
    return {
      cropperSettings: {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        widthSize: null,
        type: null,
      },
      required,
      imageUrl: this.$store.state.app.baseURL,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['corporatePolicies/dataItem']
    },
    setResolution() {
      let resolution = null
      let width = null
      if (this.dataItem.id_corporate_policies_type === '1') {
        resolution = 1170 / 520
        width = 1170
      }
      if (this.dataItem.id_corporate_policies_type === '2') {
        resolution = 370 / 475
        width = 370
      }
      if (this.dataItem.id_corporate_policies_type === '3') {
        resolution = 1170 / 520
        width = 1170
      }
      if (this.dataItem.id_corporate_policies_type === '4') {
        resolution = 570 / 455
        width = 570
      }
      return { resolution, width }
    },
  },
  methods: {
    setModal(type) {
      if (type === 'corporate_policies') {
        this.cropperSettings = {
          modalStatus: true,
          fileName: 'corporate_policies-image.jpg',
          folder: 'corporate_policies',
          ratio: this.setResolution.resolution,
          widthSize: this.setResolution.width,
          type: 'corporate_policies',
        }
      }
    },
    closeModal() {
      this.cropperSettings = {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        type: null,
      }
    },
    setUploadImage(item) {
      this.dataItem.image = item.filename
      this.dataItem.thumb = item.thumb
      this.dataItem.image_webp = item.filename_webp
      this.dataItem.thumb_webp = item.thumb_webp
      this.dataItem.mediaData = item
      this.cropperSettings.modalStatus = false
    },
  },
}
</script>
